import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Cream marketing hero shown on the left of the Login / Register pages:
 * Mesoon wordmark, a two-tone headline, a subtitle, a product screenshot, and a
 * row of four feature tiles. Hidden on small screens (see Login.css). The hero
 * image is optional — if /images/login-hero.png is missing it simply hides.
 */
const FEATURES = [
  { key: 'qrOrdering', Icon: QrIcon },
  { key: 'liveAnalytics', Icon: AnalyticsIcon },
  { key: 'kitchenDisplay', Icon: KitchenIcon },
  { key: 'multiLocation', Icon: MultiLocationIcon }
];

const AuthHero = () => {
  const { t } = useTranslation();

  return (
    <div className="auth-hero">
      <div className="auth-hero-content">
        <Link to="/" className="auth-hero-brand" aria-label={t('brand.name', 'Mesoon')}>
          <img src="/mesoon-logo.svg" alt="" width="36" height="36" />
          <span>{t('brand.name', 'Mesoon')}</span>
        </Link>

        <h1 className="auth-hero-title">
          <span className="accent">{t('auth.login.heroTitleAccent1', 'Smart')}</span>{' '}
          {t('auth.login.heroTitleRest1', 'Ordering.')}
          <br />
          <span className="accent">{t('auth.login.heroTitleAccent2', 'Stronger')}</span>{' '}
          {t('auth.login.heroTitleRest2', 'Restaurants.')}
        </h1>

        <p className="auth-hero-subtitle">{t('auth.login.heroSubtitle')}</p>

        <div className="auth-hero-image">
          <img
            src="/images/login-hero.png"
            alt=""
            loading="lazy"
            onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
          />
        </div>

        <ul className="auth-features">
          {FEATURES.map(({ key, Icon }) => (
            <li key={key} className="auth-feature">
              <span className="auth-feature-icon"><Icon /></span>
              <span className="auth-feature-title">{t(`auth.login.features.${key}.title`)}</span>
              <span className="auth-feature-desc">{t(`auth.login.features.${key}.desc`)}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

function QrIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" /><path d="M14 14h3v3M21 14v7h-7" />
    </svg>
  );
}
function AnalyticsIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 3v18h18" /><path d="M7 14l4-4 3 3 5-6" />
    </svg>
  );
}
function KitchenIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 12a7 7 0 0 1 14 0" /><line x1="3" y1="16" x2="21" y2="16" /><line x1="5" y1="20" x2="19" y2="20" />
    </svg>
  );
}
function MultiLocationIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="9" cy="9" r="2.5" />
      <path d="M9 13.5c-3 0-5 1.5-5 3.5v1h10v-1c0-2-2-3.5-5-3.5z" /><path d="M16 7.5a2.5 2.5 0 1 1 0 5" />
      <path d="M16 14c2.5 0 4 1.3 4 3v1h-4" />
    </svg>
  );
}

export default AuthHero;
